// extracted by mini-css-extract-plugin
export default {"item":"ContractStatistics_item__B5reY","title":"ContractStatistics_title__h+rXn","data":"ContractStatistics_data__qRyUr"};